import api from '../api';

import { ParamsDataGetFitClientScheduling } from 'utils/typeServices';

export const GetFitClientScheduling = async () => {
    const token = localStorage.getItem('token');

    try {
        const { data } = await api.get<Array<ParamsDataGetFitClientScheduling>>('v1/Agendamento/FitClientScheduling', {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
